const chnlConfig = {
	svcHost: process.env.REACT_APP_API_HOST,
	preLogon: {
		method: 'GET',
		url: '/hc/who',
		timeout: 60000
	},
	gatewayLogon : {
		method: 'POST',
		url: '/gateway/authcontroller/staff/logon',
		timeout: 60000
	},
	retrieveEnvParam : {
		method: 'POST',
		// url: '/gateway/controller/sfp/channelDataService/retrieveEnvParam',
		url: '/channel/retrieveEnvParam.json',
		timeout: 60000
	},
	gatewayLogoff : {
		method: 'GET',
		url: '/gateway/authcontroller/logoff?idv_cmd=idv.Logoff&ts=' + new Date().getTime(),
		timeout: 60000
	},
	keepAlive : {
		method: 'GET',
		url: '/gateway/authcontroller/keepAlive',
		timeout: 60000
	},
	getClientIP: {
		method: 'GET',
		url: '/permission/retreiveCIP?timestamp=' + new Date().getTime(),
		timeout: 60000
	},
	retrieveCustomerType: {
		url: '/api/aag/wcm/wealth/api/v1/customers/retrieveCustInfo',
		method: 'GET'
	},

	// generateToken
	generateToken: {
		method: 'POST',
		url: '/authcontroller/generateToken'
	}
};

export default chnlConfig;
